export default function Label(props: {label: any, lang: string}) {

  if (!props.label) {
    return null
  }

  return (
    props.lang === 'en' ? props.label[0] : props.label[1] 
  )
}
